import React, { FunctionComponent, useCallback } from 'react';
import { ContactFormModalProps } from './contact-form-modal';
import ContactFormUpdateContainer from './contact-form-update-container';
import {
  useGetContact,
  useUpdateContact,
} from 'generated/api-client/@tanstack/react-query.gen';
import { UpdateContactRequest } from 'generated/api-client';

type ContactFormUpdateRepositoryProps = ContactFormModalProps & {
  contactId: number;
  onContactUpdated?: (contactId: number) => void;
};

const ContactFormUpdateRepository: FunctionComponent<
  ContactFormUpdateRepositoryProps
> = ({ contactId, onContactUpdated, ...rest }) => {
  const { data: existingContact } = useGetContact({
    path: {
      contactId: contactId,
    },
  });

  const { mutateAsync: updateContactMutation } = useUpdateContact();

  const updateContact = useCallback(
    async (contact: UpdateContactRequest) => {
      if (!existingContact) {
        throw Error('Cannot find current Contact');
      }

      await updateContactMutation({
        path: { contactId },
        body: contact,
      });

      onContactUpdated?.(contactId);
    },
    [contactId, existingContact],
  );

  return (
    <ContactFormUpdateContainer
      contactId={contactId}
      contact={existingContact}
      updateContact={updateContact}
      {...rest}
    />
  );
};

export default ContactFormUpdateRepository;
